import { render, staticRenderFns } from "./AcademyFundByYearStatistics.vue?vue&type=template&id=5cfc17a9&scoped=true&"
import script from "./AcademyFundByYearStatistics.vue?vue&type=script&lang=js&"
export * from "./AcademyFundByYearStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfc17a9",
  null
  
)

export default component.exports